// eslint-disable-next-line import/no-extraneous-dependencies
// import YouTubePlayer from 'youtube-player'

function selectSkipTo(skipEl) {
  if (skipEl) {
    if (
      skipEl.nodeName === 'A' ||
      skipEl.nodeName === 'BUTTON' ||
      skipEl.tabIndex > -1
    ) {
      skipEl.focus()
    } else {
      setTimeout(() => {
        const skipChildren = skipEl.querySelectorAll('a, button')
        let i = 0
        try {
          do {
            skipChildren[i].focus()
            i += 1
          } while (
            i < skipChildren.length &&
            skipChildren[i - 1] !== document.activeElement
          )
          // eslint-disable-next-line no-empty
        } catch (e) {}
      }, 10)
    }
  }
}

const closeElement = (element) => {
  element.classList.remove('h-active')
  element.classList.remove('active')
  element.classList.add('animate')
  setTimeout(() => {
    element.classList.remove('animate')
  }, 500)

  const toTriggerElementExpanded = element.getAttribute('aria-expanded')
  if (
    toTriggerElementExpanded !== undefined &&
    toTriggerElementExpanded !== null
  ) {
    element.setAttribute('aria-expanded', false)
  }

  const eventClose = new CustomEvent('closeelement')
  element.dispatchEvent(eventClose)
}

const openElement = (element) => {
  element.classList.add('active')
  element.classList.add('h-active')
  element.classList.add('animate')
  setTimeout(() => {
    element.classList.remove('animate')
  }, 500)

  const toTriggerElementExpanded = element.getAttribute('aria-expanded')
  if (
    toTriggerElementExpanded !== undefined &&
    toTriggerElementExpanded !== null
  ) {
    element.setAttribute('aria-expanded', true)
  }

  const eventOpen = new CustomEvent('openelement')
  element.dispatchEvent(eventOpen)
}

class Helpers {
  constructor() {
    this.DOM = {
      body: document.body,
      triggers: document.querySelectorAll('[data-trigger]'),
      opens: document.querySelectorAll('[data-open]'),
      close: document.querySelectorAll('[data-close]'),
      skipTo: document.querySelectorAll('[data-skipto]'),
      focusTo: document.querySelectorAll('[data-focusto]'),
      closeAllElement: document.querySelectorAll('[data-closeall]'),
      loadYoutube: document.querySelectorAll('[data-ytcode]'),
      descriptions: document.querySelectorAll('.js-description'),
    }
  }

  init() {
    this.trigger()
    this.skipTo()
    this.focusTo()
    this.closeAllElement()
    this.open()
    this.close()
    // this.loadYoutube()
    this.descriptionAction()
  }

  descriptionAction() {
    this.DOM.descriptions.forEach((el) => {
      const smallHeight = el.dataset.height ? el.dataset.height : 500
      const units = el.dataset.units ? el.dataset.units : 'px'
      const button = el.querySelector('.js-description-button')
      const text = el.querySelector('.js-description-text')
      let height = text.offsetHeight
      if (height > smallHeight) {
        if (units !== 'px') {
          text.style.height = `${smallHeight}${units}`
        } else {
          text.style.height = `${smallHeight - 20}px`
        }
        button.classList.remove('hide')
      } else {
        button.classList.add('hide')
      }
      button.addEventListener('click', () => {
        if (button.classList.contains('active')) {
          button.classList.remove('active')
          if (units !== 'px') {
            text.style.height = `${smallHeight}${units}`
          } else {
            text.style.height = `${smallHeight - 20}px`
          }
        } else {
          button.classList.add('active')
          text.style.height = `${height}px`
        }
      })
      window.addEventListener('resize', () => {
        text.classList.add('noanimation')
        text.style.height = 'auto'
        height = text.offsetHeight
        if (height > smallHeight) {
          text.style.height = `${smallHeight - 20}px`
          button.classList.remove('active')
          button.classList.remove('hide')
        } else {
          button.classList.add('hide')
        }
        text.classList.remove('noanimation')
      })
    })
  }

  // loadYoutube() {
  //   const loadendplay = (el) => {
  //     const player = YouTubePlayer(el, {
  //       width: el.offsetWidth,
  //       height: el.offsetHeight,
  //     })
  //     player.loadVideoById(el.dataset.ytcode)
  //     player.playVideo()
  //   }
  //   this.DOM.loadYoutube.forEach((el) => {
  //     el.addEventListener('click', () => {
  //       loadendplay(el)
  //     })
  //     el.addEventListener('keyup', (event) => {
  //       if (event.keyCode === 13) {
  //         loadendplay(el)
  //       }
  //     })
  //   })
  // }

  closeAllElement() {
    this.DOM.closeAllElement.forEach((el) => {
      el.addEventListener('click', () => {
        const elementsToClose = el.dataset.closeall.split(' ')
        elementsToClose.forEach((tc) => {
          const toCloseElements = document.querySelectorAll(`.${tc}`)
          toCloseElements.forEach((tce) => {
            if (tce.classList.contains('h-active')) {
              closeElement(tce)
            }
          })
        })
      })
    })
    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        const toCloseElements = document.querySelectorAll(`.h-active`)
        toCloseElements.forEach((tce) => {
          closeElement(tce)
        })
      }
    })
  }

  open() {
    const openFuction = (el) => {
      const elementsToOpen = el.dataset.open.split(' ')
      elementsToOpen.forEach((toTrigger) => {
        let toTriggerElement = el
        if (toTrigger !== 'this') {
          toTriggerElement = document.querySelector(`.${toTrigger}`)
        }
        if (
          !toTriggerElement.classList.contains('h-active') &&
          !toTriggerElement.classList.contains('animate')
        ) {
          openElement(toTriggerElement)
        }
      })
    }
    this.DOM.opens.forEach((el) => {
      el.addEventListener('click', () => {
        openFuction(el)
      })
    })
  }

  trigger() {
    const triggerFuction = (el) => {
      const elementsToTrigger = el.dataset.trigger.split(' ')
      elementsToTrigger.forEach((toTrigger) => {
        let toTriggerElement = el
        if (toTrigger !== 'this') {
          toTriggerElement = document.querySelector(`.${toTrigger}`)
        }
        // eslint-disable-next-line no-empty
        if (toTriggerElement.classList.contains('h-active')) {
          closeElement(toTriggerElement)
        } else {
          openElement(toTriggerElement)
        }
      })
    }
    this.DOM.triggers.forEach((el) => {
      el.addEventListener('click', () => {
        triggerFuction(el)
      })
    })
  }

  skipTo() {
    this.DOM.skipTo.forEach((el) => {
      el.addEventListener('click', () => {
        const skipElClass = el.dataset.skipto
        const skipEl = document.querySelector(`.${skipElClass}`)
        const elementExpanded = el.getAttribute('aria-expanded')
        setTimeout(() => {
          if (elementExpanded !== undefined && elementExpanded !== null) {
            if (elementExpanded === 'true') {
              selectSkipTo(skipEl)
            }
          } else {
            selectSkipTo(skipEl)
          }
        }, 10)
      })
    })
  }

  focusTo() {
    this.DOM.focusTo.forEach((element) => {
      const el = element
      const skipElClass = el.dataset.focusto
      const maxSize = el.dataset.focustomaxsize
      let maxsizeCheck = true
      if (maxSize !== undefined) {
        maxsizeCheck = window.matchMedia(`(max-width: ${maxSize}px)`).matches
      }
      if (maxsizeCheck) {
        el.tabIndex = 0
      }
      window.addEventListener('resize', () => {
        // eslint-disable-next-line no-shadow
        const maxSize = el.dataset.focustomaxsize
        // eslint-disable-next-line no-shadow
        let maxsizeCheck = true
        if (maxSize !== undefined) {
          maxsizeCheck = window.matchMedia(`(max-width: ${maxSize}px)`).matches
        }
        if (maxsizeCheck) {
          el.tabIndex = 0
        } else {
          el.tabIndex = -1
        }
      })
      el.addEventListener('focusin', () => {
        let skipEl = document.querySelector(`.${skipElClass}`)
        if (skipEl) {
          const skipElAll = document.querySelectorAll(`.${skipElClass}`)
          const { length } = skipElAll
          if (length > 0) {
            skipElAll.forEach((ele) => {
              if (
                ele.classList.contains('active') ||
                ele.parentElement.classList.contains('active')
              ) {
                skipEl = ele
              }
            })
          }
          // eslint-disable-next-line no-shadow
          const maxSize = el.dataset.focustomaxsize
          // eslint-disable-next-line no-shadow
          let maxsizeCheck = true
          if (maxSize !== undefined) {
            maxsizeCheck = window.matchMedia(
              `(max-width: ${maxSize}px)`
            ).matches
          }
          if (maxsizeCheck) {
            setTimeout(() => {
              if (skipEl.nodeName === 'DIV') {
                skipEl.tabIndex = 0
              }
              skipEl.focus()
              if (document.activeElement !== skipEl) {
                if (el.dataset.focustoother) {
                  skipEl = document.querySelector(`.${el.dataset.focustoother}`)
                  skipEl.focus()
                }
              }
            }, 10)
          }
        }
      })
    })
  }

  close() {
    this.DOM.close.forEach((el) => {
      el.addEventListener('click', () => {
        const elementsToClose = el.dataset.close.split(' ')
        elementsToClose.forEach((toClose) => {
          let toCloseElement = el
          if (toClose !== 'this') {
            toCloseElement = document.querySelector(`.${toClose}`)
          }
          if (toCloseElement.classList.contains('h-active')) {
            closeElement(toCloseElement)
          }
        })
      })
    })
  }
}

export default Helpers
